const successMessages = {
    "recordAlreadyExist": "Record Already Exists",
    "OTPExpires": "OTP sent to email address, and it will expire in the next",
    "passwordChanged": "Password changed successfully",
    "success": "Success",
    "leadUpdatedSuccessfully": "Lead updated successfully",
    "proceed": "Proceed",
    "userUpdatedSuccessfully": "User updated successfully",
    "userDeleted": "User Deleted",
    "userDetailsUpdatedSuccessfully": "User Details Updated Successfully"
}
export default successMessages
